var exports = {
  "lZ": "Banner__pQquvf",
  "DR": "Box_0__CQqG55",
  "pv": "Box_2__4m020b",
  "Cz": "VerifiedHTMLBox_0__bbex62",
};

module.exports = exports;
